import React from 'react';
import { GetServerSideProps } from 'next';
import CenteredContainer from '@/common/CenteredContainer';
import TermsOfUsePageContent from '@/shared/pages/terms-of-use';

import initializePage from '../app/common/pageSetup';

const TermsOfUsePage = (): JSX.Element => (
  <>
    <CenteredContainer>
      <TermsOfUsePageContent />
    </CenteredContainer>
  </>
);

export const getServerSideProps: GetServerSideProps = (ctx) => initializePage(ctx, 'terms-of-use');

export default TermsOfUsePage;
